module.exports = __webpack_public_path__ + "static/media/Relaxation Meditation Songs Divine - Над пррвою.ba140d4a.mp3";